import React from 'react';

import { connect } from "react-redux";
import {
    Input,
    Button,
    Navbar,
    Nav,
    NavLink,
    Col,
    Row,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Label,
} from 'reactstrap'
import radioButton from '../../assets/radioButton.svg'
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
import SNPGridDisplay from "./snpGridDisplay";
import moment from 'moment';
import { NavLink as RRNavLink } from 'react-router-dom';
import {
    fetchBuilding,
    fetchFloors,
    fetchFloorPlan,
    fetchLocationResultsData,
    uploadResults,
    downloadResultData,
    fetchFilterOptions,
    fetchSNPMatrix,
    fetchGroups,
    fetchBatchNumbers
} from '../../actions'
import NavBar from '../NavBar/navBar'
import './snpDistance.css';
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import Tour from '../../Tour';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import uploadIcon from '../../assets/upload.svg'
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload} from '@fortawesome/free-solid-svg-icons';
import deleteIconRed from '../../assets/delete-red-outline.svg'

// const ExcelFile = ExcelFile;
// const ExcelSheet = ExcelFile.ExcelSheet;
// const ExcelColumn = ExcelFile.ExcelColumn;
const dataset = [ ...Array(10)].map((e, i) => {
        let data = {}
        data["barcode"] = `barcode${++i}`
        data["ct"] = null
        for (let j = 0; j < 10; j++)
            data[`barcode${j+1}`] = i-1===j?0:null
        return data 
    })
let building=sessionStorage.getItem("building")
let buildingId=sessionStorage.getItem("buildingId")
let buildingName=sessionStorage.getItem("buildingName")
let floor=sessionStorage.getItem("floor")
let floorId=sessionStorage.getItem("floorId")
let floorName=sessionStorage.getItem("floorName")

let errorDetails = ""


class SNPDistance extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchFilterOptions()
        this.props.fetchBuilding()
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.onSelectFloor = this.onSelectFloor.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        
        building=sessionStorage.getItem("building")
        floor=sessionStorage.getItem("floor")
        this.floorInitialState = {
            resultBuilding: building?building:localStorage.getItem("guest")?"BldgA":"",
            resultFloor: floor?floor:localStorage.getItem("guest")?20000:"",
            floorId: floorId?floorId:localStorage.getItem("guest")?20000:"",
            buildingId: buildingId?buildingId:localStorage.getItem("guest")?20000:"",
            buildingName: buildingName?buildingName:localStorage.getItem("guest")?"Building A":"",
            floorName: floorName?floorName:localStorage.getItem("guest")?"Floor A":"",
            show: false,
            organism: localStorage.getItem("guest")?"Salmonella":"",
            batchNumber: localStorage.getItem("guest")?"Batch 01":"",
            data: [],
            labels: [],
            group: [],
            toggleUploadModal: false,
            SNPreaultData: [],
            selectedfilters:[]
        }
        this.state = Object.assign(this.floorInitialState);
        setTimeout(() => {
            if(localStorage.getItem("guest")){
                this.getBatchNumber()
                this.applyFilter()
            }
        });
    }


    componentWillMount()
    {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentDidMount() {   
        if(sessionStorage.getItem("building"))
        this.onSelectBuilding("",true)


        // Below function calls are for the automatic setting of values on load
        this.props.fetchBuilding().then( () =>{
            this.onSelectBuilding("", 'onMount')
            this.onSelectFloor("", "onMount")
            if(!(localStorage.getItem('guest') || localStorage.getItem('species'))){
                this.onSelectOrganism()

                if(this.state.organism && this.state.resultFloor){
                    let data = {
                        floor_id: this.state.resultFloor,
                        organism: this.state.organism,
                    }
                    this.props.fetchBatchNumbers({ data }).then(() => {
                        if(this.props.batchNoList && this.props.batchNoList.batchNoList && this.props.batchNoList.batchNoList.length>0){
                            this.onSelect()
                        }
                        this.applyFilter()
                    })
                }
            }  
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: 865, height: 550 });
    }
    

onSelectBuilding = (event,flag=false) => {
    if(flag===false)
    {
    const {value,selectedOptions}=event.target
    sessionStorage.setItem("building",value)
    sessionStorage.setItem("buildingId",selectedOptions[0].id)
    sessionStorage.setItem("buildingName",selectedOptions[0].innerText)
    sessionStorage.setItem("floor","")
    }
    else if(flag=="onMount" 
    && this.props.buildingList 
    && this.props.buildingList.length>0
    ){
        sessionStorage.setItem("building", this.props.buildingList[0]['building_id'])
        sessionStorage.setItem("buildingId", this.props.buildingList[0]['id'])
        sessionStorage.setItem("buildingName", this.props.buildingList[0]['building_name'])
        if(this.props.buildingList[0]['floors'].length==0){
            sessionStorage.setItem("floorName","")
            sessionStorage.setItem("floorId","")
            sessionStorage.setItem("floor","")
      }
    }
        this.setState({
            ...this.state,
            resultBuilding:sessionStorage.getItem("building"),
            buildingId: sessionStorage.getItem("buildingId"),
            buildingName:sessionStorage.getItem("buildingName"),
            resultFloor: "",
            show: false,
        }, async() => {
           await this.props.fetchFloors(this.state.buildingId)
            if(sessionStorage.getItem("floor"))
                this.onSelectFloor("","onMount")
        })
    }

    onSelectFloor = (event,flag=false) => {
        if(flag===false)
        {
        const {value,selectedOptions}=event.target
        sessionStorage.setItem("floorName",selectedOptions[0].innerText)
        sessionStorage.setItem("floorId",selectedOptions[0].id)
        sessionStorage.setItem("floor",value)
        }
        else if (flag == "onMount" 
        && this.props.buildingList 
        && this.props.buildingList.length>0
        && this.props.buildingList[0]['floors']
        && this.props.buildingList[0]['floors'].length>0){
            sessionStorage.setItem("floorName", this.props.buildingList[0]['floors'][0]['floor_name'])
            sessionStorage.setItem("floorId", this.props.buildingList[0]['floors'][0]['id'])
            sessionStorage.setItem("floor", this.props.buildingList[0]['floors'][0]['id'])
        }       
         this.setState({
            ...this.state,
            resultFloor: sessionStorage.getItem("floor"),
            floorId:sessionStorage.getItem("floorId"),
            floorName:sessionStorage.getItem("floorName"),
            show: false,
        })
    }

    getBatchNumber = () => {
        if (this.state.resultFloor && this.state.resultBuilding
            && this.state.organism) {
            var data = {
                floor_id: this.state.resultFloor,
                organism: this.state.organism,
            }
            this.props.fetchBatchNumbers({ data })
        }
    }

    onSelectOrganism = (event) => {
        if(event === undefined){
            this.setState({
                ...this.state,
                batchNumber:"",
                organism: this.props.filters.organismMaxCount,
                show: false,
            }, () => {
                this.getBatchNumber()
            })
        }
        else{
            this.setState({
                ...this.state,
                batchNumber:"",
                [event.target.name]: event.target.value,
                show: false,
            }, () => {
                this.getBatchNumber()
            })    
        }
    }


    onSelect = (event) => {
        if(event === undefined){
            this.setState({
                ...this.state,
                batchNumber: this.props.batchNoList.batchNoList[0][0],
                show: false,
            }, () => {
                this.getBatchNumber()
            })
        }
        else{
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,
                show: false,
            }, () => {
                this.getBatchNumber()
            })
        }
        
    }


    ErrorDetails = () => {
        appInsights.trackTrace({message: errorDetails, properties:{page: "snpDistance"}, severityLevel: SeverityLevel.Verbose})
        if(window.location.pathname.includes('/results/snpresults/') || window.location.pathname.includes('/results/snpresults')){
            toast.error(errorDetails, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        errorDetails = ""
        return true
    }

    isvalidData = (data) => {
        if (data.resultBuilding && data.floorId && data.batchNumber && data.organism) {
            return true
        }
        else if (!data.resultBuilding) {
            errorDetails = "Please select a Building!"
            return false
        }
        else if (!data.floorId) {
            errorDetails = "Please select a Floor!"
            return false
        }
        else if (!data.batchNumber) {
            errorDetails = "Plaese select a batchNumber!"
            return false
        }
        else if (!data.organism) {
            errorDetails = "Plaese select a organism!"
            return false
        }

    }


    applyFilter = () => {
        if (this.isvalidData(this.state)) {
            var data = {
                organism: this.state.organism,
                floor__id: this.state.floorId,
                batch_no: this.state.batchNumber,
            }
            this.setState({selectedfilters:data})
            this.props.fetchSNPMatrix(data).then(response => {
                if (response.status === 200 && response.data) {
                    appInsights.trackTrace({message: 'SNP Result is fetched successfully', properties:{page: "snpDistance", name: this.state.floorName, id: this.state.floorId, organism: this.state.organism, batchNumber: this.state.batchNumber}, severityLevel: SeverityLevel.Information});
                    let data = {};
                    let barcodes = []
                    response.data["data"].forEach((item, index)=>{
                        if(item['analysis_result_data'] && Object.keys(item['analysis_result_data']).length){
                            data[item['sample']['barcode']] = [item['analysis_result_data'], item];
                            barcodes.push(Object.keys(item['analysis_result_data']))
                        }
                    })
                    let intersector = (arr1, arr2) => arr1.filter(item1 => arr2.some(item2 => item1.id === item2.id))
                    barcodes = barcodes.reduce(intersector, Object.keys(data))
                    let snpList = []
                    Object.keys(data).forEach((barcode) => {
                        let snpRelative = []
                        barcodes.forEach((item) =>{snpRelative.push(data[barcode][0][item])})
                        snpRelative.push(data[barcode][1])
                        snpRelative.push(data[barcode][2])
                        snpList.push(snpRelative)
                    })
                    this.setState({
                        data: snpList,
                        labels: barcodes,
                        show: true,
                        result: response.data["data"],
                        SNPreaultData:response.data
                    })
                }
                else {
                    let message = "Unable to fetch SNP result!"
                    appInsights.trackTrace({message: message, properties:{page: "snpDistance", name: this.state.floorName, id: this.state.floorId, organism: this.state.organism, batchNumber: this.state.batchNumber}, severityLevel: SeverityLevel.Error});
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch((error) => {
                let message = "Error in fetching SNP result!"
                appInsights.trackTrace({message: message, properties:{page: "snpDistance", name: this.state.floorName, id: this.state.floorId, organism: this.state.organism, batchNumber: this.state.batchNumber, error: error}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })

            this.props.fetchGroups({organism:this.state.organism.split(" ")[0]}).then(response => {
                if (response.status === 200 && response.data) {
                    appInsights.trackTrace({message: "SNP group is fetched successfully!", properties:{page: "snpDistance", name: response.data.organism}, severityLevel: SeverityLevel.Information});
                    this.setState({
                        group: response.data.groups.split(',')
                    })
                }
                else {
                    let message = "Unable to fetch SNP groups!"
                    appInsights.trackTrace({message: message, properties:{page: "snpDistance", name: this.state.organism}, severityLevel: SeverityLevel.Error});
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch((error) => {
                let message = "Error in fetching organism groups!"
                appInsights.trackTrace({message: message, properties:{page: "snpDistance", name: this.state.organism, error: error}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
            this.updateWindowDimensions()
        }
        else {
            this.ErrorDetails()
            this.setState({
                resultsData: [],
                SNPreaultData: []
            })
        }
    }

    resetData = () => {
        this.setState({
            ...this.floorInitialState, 
            resultBuilding: "",
            buildingId: "",
            buildingName: "",
            resultFloor: "",
        },()=>{
            if(localStorage.getItem("guest"))
                this.getBatchNumber()
        })
        window.sessionStorage.removeItem('applyFilterAutoSelect')
        window.sessionStorage.removeItem('buildingNameAutoSelect')
        window.sessionStorage.removeItem('floorNameAutoSelect')
        window.sessionStorage.removeItem('buildingName')
        window.sessionStorage.removeItem('building')
        window.sessionStorage.removeItem('buildingId')
        window.sessionStorage.removeItem('floorName')
        window.sessionStorage.removeItem('floor')
        window.sessionStorage.removeItem('floorId')          
    }

    uploadResults = () => {
        if(!this.state.resultFile){
            let message = "SNP Results Upload failed. Please choose a file!"
            appInsights.trackTrace({message: message, properties:{page: "snpDistance", type: "SNP"}, severityLevel: SeverityLevel.Verbose})
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else{
            this.setState({loader: true})
            this.props.uploadResults(this.state.resultFile, true).then((res) => {
                if (res && res.data) {
                    this.setState({ loader: false, isUploadModalOpen: false, resultFile: ""})
                    this.props.downloadResultData()
                    let total = res.data.number_of_results_uploaded + res.data.number_of_invalids+res.data.number_of_duplicates
                    let uploaded = res.data.number_of_results_uploaded
                    let message = (uploaded ) + " out of " + (total)+" results uploaded successfully."
                    appInsights.trackEvent({name: 'SNP Results Uploaded', properties:{uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates}});
                    appInsights.trackTrace({message: 'SNP Results Uploaded', properties:{uploaded: uploaded, invalid: res.data.number_of_invalids, duplicates: res.data.number_of_duplicates}, severityLevel: SeverityLevel.Information})
                    toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
                    if(res.status===203){
                        message = "Found " + (res.data.number_of_invalids) + " results with invalid data."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                    else if(res.status===202){
                        message = "Found " + (res.data.number_of_duplicates) + " duplicate barcodes."
                        toast.warn(message, { position: toast.POSITION.BOTTOM_RIGHT })
                    }
                }
            }).catch((e) => {
                this.setState({ loader: false })
                if (e.status === 400){
                    let message=''
                    if(e.data['invalid_headers'] || e.data['result_headers'] || e.data['barcode'])
                        message = "Upload failed due to invalid headers, please refer the template for more updates!!"
                    else if(e.data['empty_data'])
                        message = "Upload failed due to empty data in the file!!"
                    else if(e.data['snp_error'])
                        message = e.data['snp_error']
                    else if(e.data['number_of_invalids'])
                        message = "Upload failed due to invalid data!!"
                    else
                        message = "Upload failed, try again after rechecking the data!!"
                        appInsights.trackTrace({message: message, properties: {file: this.state.resultFile, page: "snpDistance", type: 'SNP', error: e}, severityLevel: SeverityLevel.Error})
                        toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
                else {
                    let message = "Upload failed due to an unexcpected error!!."
                    appInsights.trackTrace({message: message, properties: {file: this.state.resultFile, page: "snpDistance", type: 'SNP', error: e}, severityLevel: SeverityLevel.Error})
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    })
                }
            })
        }
    }

    getFileName = () => {
        let Filename = "Results_" + moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.setState({ fileName: Filename })
    }

    onChangeFile  = event => {
        let allowedExtensions = ["xlsx"];
        let file = event.target.files;
        if (file.length > 0 && !allowedExtensions.includes(file[0].name.split('.').slice(-1)[0])){
            appInsights.trackTrace({message: "Incorect file format, Please choose an Excel file (.xlsx)", properties:{page: "snpDistance", type: 'SNP'}, severityLevel: SeverityLevel.Verbose})
            toast.warn("Incorect file format, Please choose an Excel file (.xlsx)", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else { 
            file[0]['displayName'] = file[0].name.split(".")[0];
            if(file[0]['displayName'].length > 15) file[0]['displayName'] = file[0]['displayName'].substring(0,15) + '...'; 
            this.setState({  resultFile: file[0] });
            }
    }
    clearUpload = () => {
        this.setState({ resultFile: undefined });
    }

    toggleUploadModal = () => {
        this.setState(prevState => ({
            isUploadModalOpen: !prevState.isUploadModalOpen,
        }));
    }


    render() {
        return (
            <div data-tut="reactour__results" className="page-layout">
                <NavBar />
                <div className='dashboard-overview samples-page results-page' data-tut="reactour__results" >
                    <div className="dashboard-content-25" ref={(divElement) => { this.divElement = divElement }}>
                        <Row className="sample-list-header" form>
                            <Navbar className="navbar-results" light expand="md">
                                <Nav navbar>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/viewresults"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>All Results</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Track Result</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding bottom-border" activeClassName="active" to="/results/snpresults/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>SNP Result</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/biomeresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt='' />Microbiome Result</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link remove-horizontal-padding" activeClassName="active" to="/results/speciesdensity/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=""/>Species Density</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                        <div className='sample-input-area' data-tut="reactour__apply">
                            <Row form >
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultBuilding?this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultBuilding" value={this.state.resultBuilding} onChange={this.onSelectBuilding}>
                                        <option value="" default disabled>Building*</option>
                                        {this.props.buildingList.map((building, key) => {
                                            return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.resultFloor?this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultFloor" value={this.state.resultFloor} onChange={this.onSelectFloor}>
                                        <option value="" default disabled>Floor*</option>
                                        {this.props.floorsList.map((floor, key) => {
                                            return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                        })}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.organism?this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="organism" value={this.state.organism} onChange={this.onSelectOrganism}>
                                        <option value="" default disabled>Organism*</option>
                                        {this.props.filters.organismList ? this.props.filters.organismList.map((organism) => {
                                            return <option key={organism} className="dashboard-options" id={organism} value={organism}>{organism}</option>
                                        }) : null}
                                    </Input>
                                </Col>
                                <Col sm={4} md={3} lg={2}>
                                    <Input className={this.state.batchNumber?this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="batchNumber" value={this.state.batchNumber} onChange={this.onSelect}>
                                        <option value="" default disabled>Batch Number*</option>
                                        {(this.props.batchNoList && this.props.batchNoList.batchNoList) ? this.props.batchNoList.batchNoList.map((sample, key) => {
                                            return <option className="dashboard-options" id={sample} key={key} value={sample}>{sample}</option>
                                        }) : null}
                                    </Input>
                                </Col>
                                <Col className="clear-apply-end" data-tut="reactour__apply">
                                    <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>CLEAR</Button>
                                    <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>APPLY</Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="grid-data width">
                        <Row className="sample-list-header" form>
                            <Col className="result-floor-view">Grid Map</Col>
                            <Col className="upload-col-result" data-tut="reactour__uploads">
                                        {!localStorage.getItem("guest")?
                                        <Button
                                        className="export-data-button"
                                        id="export-data-button"
                                        labelColor="#000"
                                        backgroundColor="#FFF"
                                        fullWidth={true}
                                        onClick={() => this.toggleUploadModal()}
                                    ><img src={uploadIcon} className='nav-icons' alt=''/>
                                        Upload Results</Button>:null}</Col>  
                        </Row>     
                        <Modal isOpen={this.state.isUploadModalOpen} toggle={this.toggleUploadModal} size="lg">
                            <ModalHeader toggle={this.toggleUploadModal} className="edit-popup">Upload Results</ModalHeader>
                            <ModalBody className="upload-body">
                                <Row xs="2">
                                    <Col>
                                        <FontAwesomeIcon className="overlay-upload-icon upload-sample-icon-position"  icon={faUpload} size="lg" />
                                        <Input
                                        className="edit-input-values edit-input-values-file upload-sample-file"
                                        type="file"
                                        accept=".xlsx, .csv"
                                        placeholder="please enter file"
                                        onClick={(event)=> { 
                                            event.target.value = null
                                        }}  
                                        onChange={this.onChangeFile}                           
                                        data-title={'Choose File'}
                                        />
                                    </Col>
                                    <Col className="upload-sample-last">
                                            {this.state.resultFile?
                                            <Col className="upload-filename">
                                            <Label className="title">{this.state.resultFile.displayName}</Label>
                                            <img src={deleteIconRed} className="overlay-upload-icon trash-icon" alt=''
                                            onClick={this.clearUpload}
                                            />
                                            </Col>: <></>}
                                    </Col>
                                    <Col>
                                        <div className="vertical-line"></div>
                                        <div style={{display: "none"}} element={<Button id="export-data-button" className="export-data-button  sample-template-button" onClick={this.getFileName}>Download Result Template</Button>} filename={this.state.fileName}>
                                        <div data={dataset} name="Results">
                                            <div label="*BarCode" value="barcode"/>
                                            <div label="*ComplexTypecgMLST" value="ct"/>
                                            <div label="barcode1" value="barcode1"/>
                                            <div label="barcode2" value="barcode2"/>
                                            <div label="barcode3" value="barcode3"/>
                                            <div label="barcode4" value="barcode4"/>
                                            <div label="barcode5" value="barcode5"/>
                                            <div label="barcode6" value="barcode6"/>
                                            <div label="barcode7" value="barcode7"/>
                                            <div label="barcode8" value="barcode8"/>
                                            <div label="barcode9" value="barcode9"/>
                                            <div label="barcode10" value="barcode10"/>
                                        </div>
                                    </div>
                                        <div className="edit-popup">
                                            <h5 className="modal-text lowertag lowertag-align">* are mandatory to fill</h5>
                                        </div>
                                    </Col>
                                </Row> 
                            </ModalBody>
                            <ModalFooter className="float-sm-right bottom-options">
                                <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={this.clearUpload}>Clear</Button>
                                <Button
                                    className="button-size custom-button save-upload-delete-button"
                                    id="export-data-button"
                                    labelColor="#000"
                                    backgroundColor="#FFF"
                                    fullWidth={true}
                                    onClick={() => this.uploadResults()}
                                >
                                    Save
                                </Button>
                                {this.state.loader ? <Spinner size="sm" color="primary" /> : null}
                            </ModalFooter>
                        </Modal>
                        {this.state.show ?
                            <div data-tut="reactour__resultView">
                                {this.state.data.length > 0 && this.state.group.length > 0?
                                    <SNPGridDisplay className="Data-Table"
                                        labels={this.state.labels}
                                        data={this.state.data}
                                        result={this.state.result}
                                        groups={this.state.group}
                                        cellRender={value => value && <div>{value}</div>}
                                        SNPreaultData={this.state.SNPreaultData}
                                        selectedfilters ={this.state.selectedfilters}
                                    />
                                        : 
                                <div className="no-data-msg results-data">Data doesn't exist for this criteria. Select another criteria and click on Apply button to view data. </div>
                                }
                            </div>
                            :
                            <div data-tut="reactour__resultView" className="no-data-msg results-data">Select above criteria and click on Apply button to view data. </div>
                        }
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        locationAreas: state.location_data.locationData,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        filters: state.results_data.filters,
        batchNoList: state.results_data.batchNoList
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchLocationResultsData,
        downloadResultData,
        fetchBuilding,
        fetchFloors,
        fetchFloorPlan,
        fetchFilterOptions,
        fetchSNPMatrix,
        fetchGroups,
        uploadResults,
        fetchBatchNumbers,
    }
)(SNPDistance), 'SNP Results', 'SNPDistance')